module.exports = __webpack_public_path__ + "img/39.31acbae.jpg";